import React from "react";
import { DutyItemValidationResult } from "./Interfaces";

export class PilotDutyErrorHelper {
    static hasErrors(errors: DutyItemValidationResult[], fieldName: string, dutyItemId: number): boolean {
        const message = errors.find((error) => {
            return error.dutyItemId === dutyItemId && error.entityName === fieldName;
        });
        return message !== undefined;
    }

    static getErrorMessage(errors: DutyItemValidationResult[], fieldName: string, dutyItemId: number): string {
        const error = errors.find((error) => {
            return error.dutyItemId === dutyItemId && error.entityName === fieldName;
        });
        return error === undefined ? "" : error.message;
    }
}
